import { flow, map as mapFp, zip, get, filter } from 'lodash/fp';
import { map } from 'lodash';
import './index.less';
import { getBoudingClientRect, findElement, getComputedStyle } from './utils';
import MaskItem from './mask-item';

const findMaskItem = findElement('mask-item');

export default {
    name: 'EditLayout',
    props: {
        layoutConfig: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            CellInfoList: [],
            SelectedColName: ''
        };
    },
    computed: {
        layoutConfigMap() {
            const map = new Map();
            this.layoutConfig.forEach(item => {
                map.set(item.Name, item);
            });
            return map;
        }
    },
    mounted() {
        this.DragInfo = null;
        this.CellInfoList = this.getCellInfoList();
        this.GridBoundary = this.$parent.$el
            .querySelector('.grid-layout')
            .getBoundingClientRect();
        this.$forceUpdate();
    },
    methods: {
        getCellInfoList() {
            const cellList = Array.from(
                this.$parent.$el.querySelector('.grid-layout').children
            ).filter(item => getComputedStyle(item).display !== 'none');

            return flow([
                mapFp(getBoudingClientRect),
                zip(map(cellList, get('dataset.colName'))),
                mapFp(([colName, clientRect]) => ({
                    Boundary: clientRect,
                    ColName: colName
                }))
            ])(cellList);
        },
        /**
         *
         * @param {{ ColName: string, Boundary: DOMRect }} cellInfo
         * @returns {import('vue').VNode}
         */
        renderMaskItem(cellInfo) {
            return (
                <MaskItem
                    onDrag={this.onDrag}
                    onDrop={this.onDrop}
                    selectedColName={this.SelectedColName}
                    cellInfo={cellInfo}
                    gridBoundary={this.GridBoundary}
                />
            );
        },
        /**
         * @param {MouseEvent} e
         */
        onMousedown(e) {
            this.SelectedColName =
                findMaskItem(document.elementsFromPoint(e.pageX, e.pageY))
                    ?.dataset?.colName ?? '';
        },
        onDrag(info) {
            this.DragInfo = info;
        },
        onDrop(info) {
            const { direction, cellInfo } = info;

            switch (direction) {
                case 'top':
                    break;
                case 'right':
                    break;
                case 'bottom':
                    break;
                case 'left':
                    break;
                case 'inner':
                    break;
                default:
            }

            this.DragInfo = null;
        }
    },
    render(h) {
        if (!this.GridBoundary) {
            return null;
        }
        const children = this.CellInfoList.map(cellInfo =>
            this.renderMaskItem(cellInfo)
        );
        return (
            <div class="edit-layout" onMousedown={this.onMousedown}>
                {children}
            </div>
        );
    }
};
